import { LockOutlined } from "@ant-design/icons";
import { Button, Card, Form, Input, Typography } from "antd";
import { Link } from "react-router-dom";
import { PhoneInput } from "@/shared/components/PhoneInput";
import { useLogin } from "../hooks/useAuth";
import type { LoginRequest } from "../types";

const { Title, Text } = Typography;

export function LoginForm() {
	const [form] = Form.useForm<LoginRequest>();
	const { mutate: login, isPending } = useLogin();

	const onFinish = (values: LoginRequest) => {
		login(values);
	};

	return (
		<Card className="w-full max-w-md shadow-lg">
			<div className="text-center mb-8">
				<Title level={2} className="mb-2!">
					M Smart
				</Title>
				<Text type="secondary">Hisobingizga kirish</Text>
			</div>

			<Form
				form={form}
				name="login"
				onFinish={onFinish}
				layout="vertical"
				requiredMark={false}
				size="large"
			>
				<Form.Item
					name="phone"
					label="Telefon raqam"
					rules={[
						{
							required: true,
							message: "Telefon raqamingizni kiriting",
						},
						{
							pattern: /^\+998\d{9}$/,
							message: "To'liq 9 ta raqam kiriting",
						},
					]}
				>
					<PhoneInput id="login-phone" size="large" />
				</Form.Item>

				<Form.Item
					name="password"
					label="Parol"
					rules={[
						{
							required: true,
							message: "Parolingizni kiriting",
						},
						{
							min: 4,
							message: "Parol kamida 4 ta belgidan iborat bo'lishi kerak",
						},
					]}
				>
					<Input.Password
						prefix={<LockOutlined className="text-gray-400" />}
						placeholder="Parol"
						autoComplete="current-password"
						id="login-password"
					/>
				</Form.Item>

				<Form.Item className="mb-0!">
					<Button type="primary" htmlType="submit" loading={isPending} block id="login-submit">
						Kirish
					</Button>
				</Form.Item>
			</Form>

			<div className="text-center mt-4">
				<Text type="secondary">
					Hisobingiz yo'qmi?{" "}
					<Link to="/login/register" className="text-blue-600 hover:text-blue-800">
						Ro'yxatdan o'tish
					</Link>
				</Text>
			</div>
		</Card>
	);
}
